import {ArrowLeft, ArrowRight, MoreHorizontalIcon} from 'lucide-react'
import * as React from 'react'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'
import {tv} from 'tailwind-variants'

function Pagination({className, ...props}: React.ComponentProps<'nav'>) {
  return <nav role='navigation' aria-label='pagination' data-slot='pagination' className={cn('mx-auto flex w-full justify-center', className)} {...props} />
}

function PaginationContent({className, ...props}: React.ComponentProps<'ul'>) {
  return <ul data-slot='pagination-content' className={cn('flex flex-row items-center gap-3', className)} {...props} />
}

function PaginationItem({...props}: React.ComponentProps<'li'>) {
  return <li data-slot='pagination-item' {...props} />
}

type PaginationLinkProps = {
  isActive?: boolean
} & React.ComponentProps<'button'>

function PaginationLink({className, isActive, disabled, ...props}: PaginationLinkProps) {
  return (
    <button
      aria-current={isActive ? 'page' : undefined}
      data-slot='pagination-link'
      data-active={isActive}
      data-disabled={disabled}
      disabled={disabled}
      className={cn(
        'border bg-background hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 disabled:border-[#AEC9DA] disabled:bg-transparent disabled:text-[#AEC9DA]',
        'border text-foreground  font-normal border-transparent hover:text-foreground',
        'data-[active=true]:border-primary data-[active=true]:bg-primary border data-[active=true]:text-white data-[active=true]:font-bold',
        'data-[disabled=true]:pointer-events-none data-[disabled=true]:border-[#D0D5DD] data-[disabled=true]:text-[#D0D5DD] data-[disabled=true]:bg-transparent',
        'p-2 rounded-md',
        className,
      )}
      {...props}
    />
  )
}

const paginationActionVariants = tv({
  base: cn('border-primary text-primary hover:text-primary'),
})

function PaginationPrevious({className, ...props}: React.ComponentProps<typeof PaginationLink>) {
  return (
    <PaginationLink aria-label='Ir para página anterior' className={cn('gap-1 px-2.5 sm:pl-2.5', paginationActionVariants(), className)} {...props}>
      <ArrowLeft className='size-5' />
    </PaginationLink>
  )
}

function PaginationNext({className, ...props}: React.ComponentProps<typeof PaginationLink>) {
  return (
    <PaginationLink aria-label='Ir para próxima página' className={cn('gap-1 px-2.5 sm:pr-2.5', paginationActionVariants(), className)} {...props}>
      <ArrowRight className='size-5' />
    </PaginationLink>
  )
}

function PaginationEllipsis({className, ...props}: React.ComponentProps<'span'>) {
  return (
    <span aria-hidden data-slot='pagination-ellipsis' className={cn('flex size-9 items-center justify-center', className)} {...props}>
      <MoreHorizontalIcon className='size-4' />
      <span className='sr-only'>Mais páginas</span>
    </span>
  )
}

export {Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious}
